import { Button, Icon, LinearProgress, Typography } from "@material-ui/core";
import React, { useState } from "react";

const Loading = (props) => {

    const [showError, SetShowError] = useState(false);

    setTimeout(() => {
        const { stopByError = false } = props;
        if (stopByError) {
            SetShowError(true);
        }
    }, 5000);

    if (props.error) {
        return (
            <div className="flex flex-1 flex-col items-center justify-center">
                <div style={{ display: "none" }}>
                    {props.error.message}
                </div>
                <Icon className="text-40 mb-16" color="action">error_outline</Icon>
                <Typography className="text-20 mb-16" color="textSecondary">
                    Ocorreu um erro durante a execução, por favor informe o administrador do sistema.
                </Typography>
                <Button onClick={() => document.location.reload(true)} variant="contained" color="secondary">Tentar novamente</Button>
            </div>
        );
    }
    else if (props.timedOut) {
        return (
            <div className="flex flex-1 flex-col items-center justify-center">
                <Icon className="text-40 mb-16" color="action">sentiment_dissatisfied</Icon>
                <Typography className="text-20 mb-16" color="textSecondary">
                    A comunicação entre seu dispositivo e nosso servidor excedeu o tempo limite...
                </Typography>
                <Button onClick={() => document.location.reload(true)} variant="contained" color="secondary">Tentar novamente</Button>
            </div>
        );
    }
    else if (props.pastDelay) {
        return (
            <React.Fragment>
                {showError ?
                    <div className="flex flex-1 flex-col items-center justify-center">
                        <Typography className="text-16 mb-16" color="textSecondary">
                            Ocorreu um erro durante a execução, tente novamente.
                        </Typography>
                    </div>
                    :
                    <div className="flex flex-1 flex-col items-center justify-center">
                        <Typography className="text-20 mb-16" color="textSecondary">Carregando...</Typography>
                        <LinearProgress className="w-xs" color="secondary" />
                    </div>
                }
            </React.Fragment>
        );
    }
    else {
        return null;
    }
};

export default Loading;
